const _ = require('lodash');
const qs = require('qs');

function buildFilters(filters = [], dateKey) {
    return filters.reduce((acc, filter) => {
        if (dateKey && filter.id === dateKey) {
            if (filter.value.startDate && filter.value.endDate) {
                acc.startDate = filter.value.startDate.format();
                acc.endDate = filter.value.endDate.format();
            } else if (filter.value.date) {
                acc.date = filter.value.date.format();
            }
        } else if (!filter.value) {
            acc[filter.id] = null;
        } else {
            acc[filter.id] = _.isArray(filter.value) ? filter.value.join() : filter.value;
        }

        return acc;
    }, {});
}

function buildSorters(sorters = []) {
    if (!sorters.length) {
        return;
    }

    let hasPreviousSort = false;

    return sorters.reduce((previousString, sorter) => {
        const comma = hasPreviousSort ? ',' : '';
        const queryParam = `${comma}${sorter.desc ? '-' : ''}${sorter.id}`;
        hasPreviousSort = true;

        return previousString + queryParam;
    }, '');
}

function addColumnsToFilters(filters = [], columns = []) {

    columns = columns.reduce((acc, item) => {
        const accessor = _.get(item, 'accessor', '');
        const dotPosition = accessor.indexOf('.');
        const show = _.get(item, 'show');
        const filter = { id: accessor.slice(0, dotPosition + 1), value: null };

        if (dotPosition > -1 && show) {
            acc.push(filter);
        }

        return acc;

    }, []);

    return _.unionWith(filters, columns, (filterItem, columnItem) => {
        if (filterItem.id === columnItem.id) {

            return filterItem;
        }
    });
}

/**
 * Builds query parameters for a paginated request
 *
 * @param {object} object - An object with filters, page, pageSize, sorters, merchantIds, and dateKey
 * @returns {string} - A string of query parameters
 */
const createQueryParams = function ({ dateKey, filters, merchantIds, payoutAccountIds, page, pageSize, sorters, columns, tableName } = {}) {
    let queryParams = {};
    if (tableName) {
        queryParams.table = tableName;
    }

    if (_.isNumber(page) && _.isNumber(pageSize)) {
        queryParams.limit = pageSize;
        queryParams.offset = page * pageSize;
    }

    if (merchantIds) {
        queryParams.merchantIds = merchantIds;
    }

    if (payoutAccountIds) {
        queryParams.payoutAccountIds = payoutAccountIds;
    }

    const sortString = buildSorters(sorters);

    if (sortString) {
        queryParams.sort = sortString;
    }

    filters = addColumnsToFilters(filters, columns);
    filters = buildFilters(filters, dateKey);

    if (_.size(filters)) {
        queryParams = Object.assign(queryParams, filters);
    }

    return qs.stringify(queryParams, { addQueryPrefix: true, strictNullHandling: true });
};

module.exports = {
    buildFilters,
    buildSorters,
    addColumnsToFilters,
    createQueryParams
};
